import * as React from "react"
import type { SVGProps } from "react"
const SvgFolderOpen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 20.71q-.82 0-1.41-.58A2 2 0 0 1 2 18.7v-12q0-.83.59-1.4A2 2 0 0 1 4 4.7h5.18a2 2 0 0 1 1.4.58L12 6.7h9q.42 0 .71.3.3.27.29.7 0 .44-.29.72a1 1 0 0 1-.71.28h-9.82l-2-2H4v12l1.98-6.57q.2-.65.73-1.04a2 2 0 0 1 1.19-.39h12.9q1.02 0 1.61.82t.32 1.76l-1.8 6a2 2 0 0 1-.74 1.04 2 2 0 0 1-1.19.38zm2.1-2H19l1.8-6H7.9z" />
  </svg>
)
export default SvgFolderOpen
